import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'

import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import { SelectField, InputField, StateSelect } from '../../components/inputs'
import {
  normalizeEndDate,
  normalizeStartDate,
} from '../../helpers/filterHelper'
import LoaderButton from '../../components/loaderButton'
import { ReduxFormProps } from '../../forms'

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy')

export type Callback<T = void> = (...args: any) => T

export interface Props {
  cancel: Callback
  clearFields?: Callback
  clear?: Callback
}

interface FormProps {
  state: string
  tier: string
  decisionDateAfter: string
  decisionDateBefore: string
  status: string
  name: string
}

export class RefiTransactionsFilterForm extends Component<
  ReduxFormProps<Props, FormProps>
> {
  static displayName = 'RefiTransactionsFilterForm'

  render() {
    const { handleSubmit, submitting, clear, cancel } = this.props

    return (
      <form
        className="form index-filter__form"
        name="RefiTransactionsFilterForm"
        onSubmit={handleSubmit}
      >
        <div className="filter">
          <div>
            <h2 className="filter__header">State</h2>
            <hr className="form__hr filter__hr" />

            <StateSelect
              defaultOption="No state selected"
              label="Select a state"
              name="state"
            />
          </div>

          <div>
            <h2 className="filter__header">Refinance Tier</h2>
            <hr className="form__hr filter__hr" />

            <Field
              label="Select a tier"
              name="tier"
              component={SelectField}
              gridClass="field filter__field"
            >
              <option value="">No tier selected</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="D">D</option>
              <option value="E">E</option>
              <option value="F">F</option>
            </Field>
          </div>

          <div>
            <h2 className="filter__header">Decision date</h2>
            <hr className="form__hr filter__hr" />
            <div className="filter__date-fields">
              <Field<any> // TODO-TS
                type="text"
                label="From"
                name="decisionDateAfter"
                format={(value) => (value === '' ? null : value)}
                component={InputField}
                placeholder="mm/dd/yyyy"
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                pipe={autoCorrectedDatePipe}
                normalize={normalizeStartDate}
                keepCharPositions={true}
                gridClass="filter__field"
              />

              <Field<any> // TODO-TS
                type="text"
                label="To"
                name="decisionDateBefore"
                format={(value) => (value === '' || value === 0 ? null : value)}
                component={InputField}
                placeholder="mm/dd/yyyy"
                mask={[
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  '/',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                pipe={autoCorrectedDatePipe}
                normalize={normalizeEndDate}
                keepCharPositions={true}
                gridClass="filter__field"
              />
            </div>
          </div>

          <div>
            <h2 className="filter__header">Status</h2>
            <hr className="form__hr filter__hr" />
            <Field<any> // TODO-TS
              label="Select a status"
              name="status"
              component={SelectField}
              aria-required="true"
              gridClass="filter__status-field filter__field"
            >
              <option value="">No status selected</option>
              <option value="PENDING">Pending</option>
              <option value="CLOSING">Closing</option>
              <option value="COMPLETE">Complete</option>
              <option value="QUALIFIED">Qualified</option>
              <option value="SOLD">Sold</option>
              <option value="CANCELLED">Cancelled</option>
              <option value="REJECTED">Rejected</option>
              <option value="EXPIRED">Expired</option>
            </Field>
          </div>
          <div>
            <h2 className="filter__header">Customer Name</h2>
            <hr className="form__hr  filter__hr" />
            <Field
              type="text"
              label="Enter a Customer name"
              name="name"
              component={InputField}
              gridClass="filter__field"
            />
          </div>

          <hr className="form__hr  filter__button-hr" />
          <div className="form__group filter__buttons">
            <LoaderButton
              type="submit"
              className="button button--primary filter__button--apply"
              isLoading={submitting}
            >
              Apply
            </LoaderButton>
            <a
              onClick={clear}
              className="button button--secondary filter__button--reset"
              aria-label="Clear"
            >
              Clear
            </a>
          </div>
          <a
            onClick={cancel}
            className="button button-link-text filter__cancel"
            data-testid="cancel-button"
          >
            Cancel
          </a>
        </div>
      </form>
    )
  }
}

export const validate = (data) => {
  const { name } = data
  const errors: Partial<FormProps> = {}

  if (!/^[a-zA-Z\s]*$/.test(name)) {
    errors.name = 'Only letters are allowed'
  }

  return errors
}

export default reduxForm<FormProps, Props>({
  form: 'refiTransactionsFilterForm',
  validate,
  enableReinitialize: false,
  destroyOnUnmount: true,
})(RefiTransactionsFilterForm)
